import { render, staticRenderFns } from "./ForgotPasswordValidate.vue?vue&type=template&id=4ded5781"
import script from "./ForgotPasswordValidate.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordValidate.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordValidate.vue?vue&type=style&index=0&id=4ded5781&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports